import React, { Fragment } from "react";
import AdminDataTable from "../../../admin/components/AdminDataTable";
import Button from "../../../../components/ui/Button";
import { PlusCircle, MoreVertical, Edit, Trash2 } from "lucide-react";
import { Menu, Transition } from "@headlessui/react";
import { mockCreator } from "../../../../data/mockData";
import RecentActivityList from "../../../../components/ui/RecentActivityList";
import Card from "../../../../components/ui/Card"; // ✨ 1. IMPORT CARD

const EventsTab = ({ events: initialEvents, onCreate, onEdit }) => {

  const eventColumns = [
    {
      header: "Event",
      key: "event",
      render: (row) => (
        <div>
          <p className="font-medium text-slate-800">{row.title}</p>
          <p className="text-sm text-slate-500">{row.date}</p>
        </div>
      ),
    },
    {
      header: "Type",
      key: "type",
      render: (row) => (
        <span
          className={`px-2 py-1 text-xs font-semibold rounded-full ${
            row.type === "Live"
              ? "bg-amber-100 text-amber-700"
              : "bg-purple-100 text-purple-700"
          }`}
        >
          {row.type}
        </span>
      ),
    },
    {
      header: "Ticket Price",
      key: "priceETB",
      render: (row) => (
        <span className="font-semibold text-slate-700">
          {row.priceETB || row.totalPrice ? `${(row.totalPrice || row.priceETB || 0).toLocaleString()} ETB` : "Free"}
        </span>
      ),
    },
    {
      header: "Tickets Sold",
      key: "ticketsSold",
      render: (row) => row.ticketsSold.toLocaleString(),
    },
    {
      header: "Status",
      key: "status",
      render: (row) => (
        <span
          className={`font-medium ${
            row.status === "Upcoming" ? "text-green-500" : "text-slate-500"
          }`}
        >
          {row.status}
        </span>
      ),
    },
    {
      header: "",
      key: "actions",
      render: (row) => (
        <Menu as="div" className="relative inline-block text-left">
          <Menu.Button
            as={Button}
            variant="ghost"
            size="sm"
            className="w-8 h-8 p-0 data-[headlessui-state=open]:bg-slate-100"
          >
            <MoreVertical size={16} />
          </Menu.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 mt-2 w-32 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
              <div className="px-1 py-1">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={() => onEdit(row)} // ✨ Use the passed-in onEdit prop
                      className={`${
                        active ? "bg-primary text-white" : "text-gray-900"
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                    >
                      <Edit className="mr-2 h-4 w-4" /> Edit
                    </button>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${
                        active ? "bg-red-500 text-white" : "text-gray-900"
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                    >
                      <Trash2 className="mr-2 h-4 w-4" /> Delete
                    </button>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      ),
    },
  ];

  const eventTransactions = mockCreator.mockTransactions
    .filter((txn) => txn.type === "Event")
    .slice(0, 5);

  const totalTicketsSold = initialEvents.reduce(
    (acc, event) => acc + event.ticketsSold,
    0
  );
  const upcomingEventsCount = initialEvents.filter(
    (event) => event.status === "Upcoming"
  ).length;
  const totalEventRevenue = 599500;

  return (
    <div className="space-y-6">
      {/* Analytics Cards */}
      <div className="grid grid-cols-1 @md:grid-cols-3 gap-4">
        <Card>
          <p className="text-sm text-slate-500">Total Event Revenue</p>
          <p className="text-2xl font-bold text-slate-800">
            {totalEventRevenue.toLocaleString()} ETB
          </p>
        </Card>
        <Card>
          <p className="text-sm text-slate-500">Total Tickets Sold</p>
          <p className="text-2xl font-bold text-slate-800">
            {totalTicketsSold.toLocaleString()}
          </p>
        </Card>
        <Card>
          <p className="text-sm text-slate-500">Upcoming Events</p>
          <p className="text-2xl font-bold text-slate-800">
            {upcomingEventsCount}
          </p>
        </Card>
      </div>

      {/* Events Table */}
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-slate-800">Your Events</h3>
        <Button variant="primary" onClick={onCreate}>
          {" "}
          <PlusCircle size={16} className="mr-2" /> Create Event
        </Button>
      </div>
      <AdminDataTable columns={eventColumns} data={initialEvents} />

      {/* Recent Activity */}
      <RecentActivityList
        title="Recent Event Activity"
        transactions={eventTransactions}
      />
    </div>
  );
};

export default EventsTab;
